module.exports = __webpack_public_path__ + "img/kobyakov.056332cf.jpg";